var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_vm._t("icon"),_vm._v("\n\t"+_vm._s(_setup.time)+"\n")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }